import { ArrowsHorizontalIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const TwoWayArrow = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ArrowsHorizontalIcon {...rest} size={Sizes[size]} color={fill} />;
};

TwoWayArrow.displayName = 'TwoWayArrow';
